import {ariaGetControlledElement} from '@vo/js/utils/aria'
import Cookies from 'js-cookie'
import { focusTrap } from '../utils/focusTrap'

export default (function () {
    const closeButton = document.querySelector('[aria-controls="market-site-switch-popup"]')
    const popup = ariaGetControlledElement(closeButton)
    const submitButton = popup?.querySelector('[data-popup-button-last]')

    if (!closeButton || !popup) return

    const openPopup = () => {
        document.body.classList.add('overflow-hidden')
        popup.classList.remove('opacity-0', 'invisible', 'pointer-events-none')

        window.setTimeout(() => {
            popup.querySelector('button').focus()
        }, 100)
    }

    const closePopup = () => {
        document.body.classList.remove('overflow-hidden')
        popup.classList.add('opacity-0', 'invisible', 'pointer-events-none')
        document.querySelector('.skip-link')?.focus()
    }

    const marketSiteSwitchPopupClosed = Cookies.get('marketSiteSwitchPopupClosed')

    if (!marketSiteSwitchPopupClosed) {
        const cookieExpiration = window.customData.marketSiteSwitchPopup.expires || 1

        setTimeout(() => openPopup(), 500)
        Cookies.set('marketSiteSwitchPopupClosed', 'true', {expires: cookieExpiration})
    }

    closeButton.addEventListener('click', () => closePopup())

    document.addEventListener('click', (event) => {
        const exceptions = ['#newsletter-popup-inner', '#market-site-switch-popup-inner', '#CybotCookiebotDialog', '#CybotCookiebotDialogBodyUnderlay', '#onetrust-consent-sdk']
        let closeAllowed = true

        exceptions.forEach(exception => {
            if (event.target.closest(exception)) {
                closeAllowed = false
            }
        })

        const isOpen = !popup.classList.contains('invisible')
        if (!isOpen) return

        if (closeAllowed) {
            closePopup()
        }
    })
    focusTrap(popup, closeButton, submitButton)
})
